export default "__VITE_ASSET__CUwr475w__"